<template>
    <section class="love-map-legend__block">
        <div class="love-map-legend__title" :class="mapLayout">
          <TxContent :content="mapTitle"></TxContent>
            <img v-show="mapHearts === 'ja'"
                 class="love-map-legend__title--img"
                 :src="heartImg"/>
        </div>
        <hr class="love-map-legend__separator">
        <div class="love-map-legend__subtitle">
          <TxContent :content="subtitle"></TxContent>
        </div>
    </section>
</template>
<script>
    import LovemapModule from "../store-mixin";

    export default {
        name: 'LoveMapTitle',
        mixins: [LovemapModule()],
        computed: {
            heartImg() {
                return this.$canUseWebP() ? this.$root.lovemap.heart : this.$root.lovemap.heart.replace('.webp', '.png')
            },
            labels() {
                switch (this.lang) {
                    case 'en': {
                        return {
                            to: 'to'
                        }
                    }
                    case 'sw': {
                        return {
                            to: 'till'
                        }
                    }
                    case 'es': {
                        return {
                            to: 'a'
                        }
                    }
                }
            },
            subtitle() {
                if (this.firstCity && this.secondCity) {
                    let distance = this.mapShowDistance === 'ja' ? ` - ${this.distance}` : '';
                    return `${this.firstCity} ${this.labels.to} ${this.secondCity}${distance}`
                }
                if (this.firstCity || this.secondCity) {
                    let city = this.firstCity || this.secondCity;
                    return `${city}`
                }
                return ` `
            },
        }
    }
</script>

<style scoped lang="scss">
    .love-map-legend {


        &__block {
            background-color: #FFFFFF;
            text-align: center;
            padding: 15px 0;
            position: relative;
            transform: translateY(-100%);
            will-change: transform;
            z-index: 999;
            /*box-shadow: 0 -2px 6px 0px #DDDDDD;*/
            ::v-deep .emoji {
              height: 55px;
              width: 55px;
              vertical-align: sub;
            }
        }

        &__title {
            color: #292929;
            text-transform: uppercase;
            font-weight: bold;
            font-family: Bodoni-72;

            &.vertical {
                font-size: 32px;
            }

            &.horizontal {
                font-size: 26px;
            }


            &--img {
                height: 40px;
                width: 40px;
                vertical-align: middle !important;
            }
        }

        &__subtitle {
            font-family: Quicksand Book;
            font-size: 20px;
            color: #292929;

            .city-name {
                text-transform: uppercase;
            }
        }

        &__separator {
            border-top: 3px solid #292929;
            margin: 13px auto;
            width: 60%;
        }
    }

</style>

